import { RouterModule, Routes } from '@angular/router';
import { ComponentsComponent } from './components/components.component';
import { PagesComponent } from './components/pages/pages.component';
import { ItemsComponent } from './components/pages/items/items.component';
import { CartComponent } from './components/cart/cart.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { AboutusComponent } from './components/aboutus/aboutus.component';
import { FaqComponent } from './components/faq/faq.component';
import { PrivacypolicyComponent } from './components/privacypolicy/privacypolicy.component';
import { ErrorsComponent } from './shared/errors/errors.component';
import { TermsandconditionComponent } from './components/termsandcondition/termsandcondition.component';
import { ShippingComponent } from './components/shipping/shipping.component';
import { ContactusComponent } from './components/contactus/contactus.component';
import { SuccessPageComponent } from './components/success-page/success-page.component';
import { NgModule } from '@angular/core';
import { FailedPageComponent } from './components/failed-page/failed-page.component';

export const routes: Routes = [
  { path: '', component: ComponentsComponent },
  {
    path: 'products',
    component: PagesComponent
    
  },
  {
    path: 'item',
    component: ItemsComponent
  },
  {
    path: 'Cart',
    component: CartComponent
  },
  {
    path: 'checkout',
    component: CheckoutComponent
  },
  {
    path: 'about',
    component: AboutusComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: 'privacy',
    component: PrivacypolicyComponent
  },
  {
    path: 'terms',
    component: TermsandconditionComponent
  },
  {
    path: 'shipping',
    component: ShippingComponent
  },
  {
    path: 'contact-us',
    component: ContactusComponent
  },
  {
    path: 'succcess-page',
    component: SuccessPageComponent
  },
  {
    path: 'failed-page',
    component: FailedPageComponent
  },
  { path: '**', component: ErrorsComponent, title: '404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload' // <--- Add this option
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
